import { gsap } from "gsap";

const techgala_newsList = document.querySelector( '.news-list' );
const techgala_newsItems = gsap.utils.toArray( '.news-list .news-item' );

let techgala_newsIndex = 0;
let techgala_newsTween = null;


function techgala_playNews() {

	if ( ! techgala_newsList || 0 === techgala_newsItems.length ) {
		return;
	}
	const item = techgala_newsItems[ techgala_newsIndex ];
	techgala_newsItems.forEach( ( newsItem ) => {
		newsItem.classList.remove( 'is-active' );
	} );
	item.classList.add( 'is-active' );
	gsap.set( item, {
		x: techgala_newsList.offsetWidth,
	} );
	techgala_newsTween = gsap.to( item, {
		x: -item.offsetWidth,
		duration: 12,
		ease: 'none',
		onComplete: () => {
			techgala_newsIndex =
				( techgala_newsIndex + 1 ) % techgala_newsItems.length;
			techgala_playNews();
		},
	} );

}

techgala_playNews();